import cmsHeader from "components/header.vue";
import cmsFooter from "components/footer.vue";
export default {
  components: {
    cmsHeader,
    cmsFooter
  }
};